import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getTicketSummaryDataEndpoint } from '../../../common/endpoints';

export const getTicketSummaryData = createApi(getTicketSummaryDataEndpoint, 'GET');

const TicketSummary = createSlice({
  name: 'TicketSummary',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTicketSummaryData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTicketSummaryData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getTicketSummaryData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default TicketSummary.reducer;